export const QUERY_STATUS = {
  PENDING: 1,
  EXECUTED: 2,
  ERROR: 3,
};

export const DMS = {
  UNKNOWN: 1,
  NTCAR: 2,
  EVA: 3,
  WINCAR: 4,
  ANON_EVA: 5,
  AUTOLINE: 6,
  AUTOLINE_EF_NEFKENS: 7,
  TEST_API: 8,
  TEST_SOW: 9,
  INCADEA: 10,
  TRUCK_VISION: 11,
  ICAR_WO: 12,
  CARIT: 13,
  AUTOLINE_OPEL_MENU: 14,
  KEYLOOP_MENUS: 15,
  CUSTOM_QUERIES: 16,
  KEYLOOP_JOBS: 17,
  EVA_BE_WO: 18,
  ICAR_PLANNING: 19,
  AUTOFLEX: 20,
  AUTOFLEX_QA_STAGING: 21,
  NEXTLANE: 22,
  WINCAR_V1_WB: 23,
  EVA_BE: 24,
  EVA_FR: 25,
  INCADEA_API: 26,
  WINCAR_V2_WB: 27,
  WINCAR_API_EVENTS: 29,
  WINCAR_API_V2_EVENTS: 30,
  KEYLOOP_MENUS_STAGING: 31,
  KEYLOOP_JOBS_STAGING: 32,
  CARIT_HYBRID: 33,
  INCADEA_HYBRID: 34,
  VINACLES: 35,
  TURBO_SAP: 36,
  GRAND_PRIX_PUBLIC_API: 37,
  CARSYS_PUBLIC_API: 38,
};

export const SEVERITY = {
  LOG: 1,
  WARNING: 2,
  ERROR: 3,
  CRITICAL: 4,
};

export const SOURCE = {
  CLIENT: 1,
  SERVER: 2,
  CUSTOM_QUERY: 3,
};

const DMS_INFO = {
  [DMS.UNKNOWN]: { name: "Unknown", group: null },
  [DMS.NTCAR]: { name: "NTCar", group: null },
  [DMS.EVA]: { name: "EVA", group: null },
  [DMS.WINCAR]: { name: "WinCar", group: null },
  [DMS.ANON_EVA]: { name: "Anonymous EVA", group: null },
  [DMS.AUTOLINE]: { name: "Autoline", group: null },
  [DMS.AUTOLINE_EF_NEFKENS]: { name: "Autoline EF Nefkens", group: null },
  [DMS.TEST_API]: { name: "Test API", group: "Test API" },
  [DMS.TEST_SOW]: { name: "Test SOW", group: null },
  [DMS.INCADEA]: { name: "Incadea", group: null },
  [DMS.TRUCK_VISION]: { name: "TruckVision", group: null },
  [DMS.ICAR_WO]: { name: "ICar WO", group: null },
  [DMS.CARIT]: { name: "CarIT", group: null },
  [DMS.AUTOLINE_OPEL_MENU]: { name: "Autoline Opel Menu", group: null },
  [DMS.KEYLOOP_MENUS]: { name: "Keyloop Menus", group: "Keyloop" },
  [DMS.CUSTOM_QUERIES]: { name: "Custom Queries", group: null },
  [DMS.KEYLOOP_JOBS]: { name: "Keyloop Jobs", group: "Keyloop" },
  [DMS.EVA_BE_WO]: { name: "EVA Be WO", group: null },
  [DMS.ICAR_PLANNING]: { name: "ICar Planning", group: null },
  [DMS.AUTOFLEX]: { name: "Autoflex", group: "Autoflex" },
  [DMS.AUTOFLEX_QA_STAGING]: { name: "Autoflex QA Staging", group: "Autoflex" },
  [DMS.NEXTLANE]: { name: "Nextlane", group: "Nextlane" },
  [DMS.WINCAR_V1_WB]: { name: "WinCar V1 WB", group: "WinCar" },
  [DMS.EVA_BE]: { name: "EVA Belgium", group: null },
  [DMS.EVA_FR]: { name: "EVA French", group: null },
  [DMS.INCADEA_API]: { name: "Incadea API", group: "Incadea" },
  [DMS.WINCAR_V2_WB]: { name: "WinCar V2 WB", group: "WinCar" },
  [DMS.WINCAR_API_EVENTS]: { name: "WinCar API Events", group: "WinCar" },
  [DMS.WINCAR_API_V2_EVENTS]: { name: "WinCar API V2 Events", group: "WinCar" },
  [DMS.KEYLOOP_MENUS_STAGING]: { name: "Keyloop Menus Staging", group: "Keyloop" },
  [DMS.KEYLOOP_JOBS_STAGING]: { name: "Keyloop Jobs Staging", group: "Keyloop" },
  [DMS.CARIT_HYBRID]: { name: "CarIT Hybrid", group: null },
  [DMS.INCADEA_HYBRID]: { name: "Incadea Hybrid", group: null },
  [DMS.VINACLES]: { name: "Vinacles", group: "Vinacles" },
  [DMS.TURBO_SAP]: { name: "Turbo SAP", group: null },
  [DMS.GRAND_PRIX_PUBLIC_API]: { name: "Grand Prix Public API", group: null },
  [DMS.CARSYS_PUBLIC_API]: { name: "Carsys Public API", group: null },
};

export const getDMSName = id => DMS_INFO[id]?.name || "";

export const getDmsGroupLabel = id => DMS_INFO[id]?.group || getDMSName(id);

export const parseDate = time => {
  if (!time) return null;
  if (time instanceof Date) return time;

  const timeValues = time.split(":");
  const date = new Date();
  date.setHours(timeValues[0] - 0, timeValues[1] - 0, timeValues[2] - 0);

  return date;
};

export const isKeyloopLocation = dmsId => [DMS.KEYLOOP_MENUS, DMS.KEYLOOP_JOBS, DMS.KEYLOOP_MENUS_STAGING, DMS.KEYLOOP_JOBS_STAGING].includes(dmsId);
